window['ThemeSection_Product'] = ({
  product,
  variant,
  featuredMediaID,
  template,
  thumbnailsPosition,
  showThumbnailsOnMobile,
}) => {
  return {
    productRoot: null,
    product: product,
    current_variant: variant,
    featured_media_id: featuredMediaID,
    current_media_id: featuredMediaID,
    loading: false,
    quantity: '1',
    options: [],
    optionHandles: [],
    storeAvailability: null,
    addedToCart: false,
    stickyAddToCartShown: false,
    template,
    thumbnailsPosition,
    showThumbnailsOnMobile,
    hasGiftCardRecipientForm: false,
    cartAddErrorMessage: null,
    get addToCartText() {
      if (this.current_variant) {
        if (this.loading) {
          return window.theme.strings.loading;
        }
        if (!this.loading && this.current_variant.available) {
          if (this.template === 'product.preorder') {
            return window.theme.strings.preOrder;
          } else {
            return window.theme.strings.addToCart;
          }
        }
        if (!this.loading && !this.current_variant.available) {
          return window.theme.strings.soldOut;
        }
      } else {
        return window.theme.strings.unavailable;
      }
    },
    get currentVariantId() {
      if (this.current_variant) {
        return this.current_variant.id;
      } else {
        return null;
      }
    },
    get currentVariantAvailabilityClosestLocation() {
      // this is on a lag to the actual current variant so that we can display an intermediary state while the fetch request is happening
      if (!Alpine.store('availability')) return null;

      const id = this.currentVariantId;
      const storeData = Alpine.store('availability').availability[id];
      if (storeData) {
        return storeData.closest_location;
      } else {
        return null;
      }
    },
    get currentVariantAvailable() {
      if (this.current_variant) {
        return this.current_variant.available;
      } else {
        return null;
      }
    },
    get currentVariantTitle() {
      if (this.current_variant && this.current_variant.title) {
        if (!this.current_variant.title.includes('Default')) {
          return this.current_variant.title;
        }
      }
      return '';
    },
    get current_price() {
      return this.current_variant.price;
    },
    get isUsingSlideshowToDisplayMedia() {
      const splideEl = this.productRoot.querySelector('.splide--product');

      if (window.Splide && this.productRoot && splideEl) {
        if (
          window.slideshows &&
          window.slideshows[`${splideEl.id}`] &&
          !window.slideshows[`${splideEl.id}`].state.is(window.Splide.STATES.DESTROYED)
        ) {
          return true;
        }
      }

      return false;
    },
    formatMoney(price) {
      let formatted = formatMoney(price, theme.moneyFormat);
      return formatted.replace(/\.00$/, '');
    },
    init() {
      // Set a product root for nested components
      // to use instead of $root (which refers to their root)
      this.productRoot = this.$root;

      if (this.$root.querySelector('[x-data="Theme_GiftCardRecipient"]')) {
        this.hasGiftCardRecipientForm = true;
      }

      // Sync with Splide product slider
      const splideProductElement = this.productRoot.querySelector('.splide--product');
      if (splideProductElement && window.slideshows) {
        const splideInstance = window.slideshows[splideProductElement.id];
        if (splideInstance) {
          splideInstance.on('moved', (newIndex) => {
            const slides = splideInstance.Components.Slides.get();
            if (slides[newIndex]) {
              const mediaId = slides[newIndex].slide.dataset.mediaId;
              if (mediaId) {
                this.current_media_id = parseInt(mediaId);
              }
            }
          });
        }
      }

      if (this.$refs.productForm) {
        this.$refs.productForm.addEventListener('submit', this.submitForm.bind(this));
      }

      this.getOptions();
      this.getAddToCartButtonHeight();

      this.$watch('current_media_id', (value, oldValue) => {
        if (showThumbnailsOnMobile) {
          this.$root.dispatchEvent(
            new CustomEvent('shapes:product:mediachange', {
              bubbles: true,
              detail: {
                media_id: this.current_media_id,
                slideshow_id: this.productRoot.querySelector('.splide--product')?.id,
              },
            }),
          );
        }
        if (this.isUsingSlideshowToDisplayMedia) return;
        this.$root
          .querySelector(`[data-product-single-media-wrapper="${oldValue}"]`)
          .dispatchEvent(new CustomEvent('mediaHidden'));
        this.$root
          .querySelector(`[data-product-single-media-wrapper="${value}"]`)
          .dispatchEvent(new CustomEvent('mediaVisible'));
      });

      this.updateStoreAvailability(this.current_variant);
    },
    getAddToCartButtonHeight() {
      window.onload = function () {
        const height = document.querySelector('.add-to-cart-btn').offsetHeight;
        document.documentElement.style.setProperty('--payment-button-height', `${height}px`);
      };
    },
    updateStoreAvailability(variant) {
      if (!this.$refs.storeAvailabilityContainer) return;
      this.storeAvailability = this.storeAvailability || new StoreAvailability(this.$refs.storeAvailabilityContainer);

      if (this.storeAvailability && variant) {
        this.storeAvailability.fetchContent(variant);
      }
    },
    updateQuantitySwatches() {
      const metafieldsEl = this.productRoot.querySelector('[data-variant-metafields]');
      if (!metafieldsEl) return;

      if (!this._variantMetafields) {
        this._variantMetafields = JSON.parse(metafieldsEl.textContent);
      }
      const metafields = this._variantMetafields;

      const quantityOptionIndex = this.product.options.findIndex(
        (o) => o.toLowerCase() === 'quantity',
      );
      if (quantityOptionIndex === -1) return;

      const quantityPosition = quantityOptionIndex + 1;
      const swatches = this.productRoot.querySelectorAll(
        `.variant-input[data-option-position="${quantityPosition}"]`,
      );

      swatches.forEach((swatch) => {
        const optionValue = swatch.dataset.optionValue;

        const variant = this.product.variants.find((v) => {
          for (let i = 0; i < this.options.length; i++) {
            if (i === quantityOptionIndex) {
              if (v.options[i] !== optionValue) return false;
            } else {
              if (v.options[i] !== this.options[i]) return false;
            }
          }
          return true;
        });

        if (!variant) return;

        const meta = metafields[variant.id];
        if (!meta) return;

        const img = swatch.querySelector('.swatch-image-container img');
        if (img && meta.quantity_swatch_image_url) {
          img.src = meta.quantity_swatch_image_url;
          img.srcset = '';
        }

        const priceContainer = swatch.querySelector('.variant-prices-container');
        if (priceContainer) {
          const priceFormatted = this.formatMoney(meta.price);
          const hasCompare = meta.compare_at_price && meta.price < meta.compare_at_price;

          let html = '<div class="variant-price tw-flex tw-items-center tw-justify-center tw-gap-[4px]">';
          const priceColorClass = hasCompare ? 'tw-text-green' : 'tw-text-heading_color';
          html += `<span class="variant-price tw-text-[18px] ${priceColorClass} tw-font-normal tw-font-primary tw-leading-[1.4]">${priceFormatted}</span>`;
          if (hasCompare) {
            const compareFormatted = this.formatMoney(meta.compare_at_price);
            html += `<span class="variant-compare-at-price tw-text-[18px] tw-text-[#A0A0A0] tw-font-normal tw-font-primary tw-leading-[1.4] tw-line-through">${compareFormatted}</span>`;
          }
          html += '</div>';

          if (hasCompare) {
            const savePercent = Math.round(
              ((meta.compare_at_price - meta.price) * 100) / meta.compare_at_price,
            );
            html +=
              '<span class="variant-save-price tw-py-[2px] tw-px-[8px] tw-bg-[#D7EFE2] tw-rounded-[30px] tw-text-[10px] tw-text-[#176339] tw-font-normal tw-font-secondary tw-leading-[1.3] -tw-tracking-[0.03em] tw-uppercase">SAVE ' +
              savePercent +
              '%</span>';
          }

          priceContainer.innerHTML = html;
        }

        const label = swatch.querySelector('label');
        let badgeEl = swatch.querySelector('.option-featured-badge');
        if (meta.featured_badge) {
          if (!badgeEl && label) {
            badgeEl = document.createElement('span');
            badgeEl.className =
              'option-featured-badge tw-pt-[4px] tw-pb-[3px] tw-px-[8px] tw-rounded-[30px] tw-bg-yellow tw-border tw-border-solid tw-border-[#0E1732] tw-text-[10px] tw-text-black tw-font-normal tw-font-secondary tw-leading-none -tw-tracking-[0.03em] tw-uppercase tw-absolute tw-top-[4px] tw-left-[4px]';
            label.appendChild(badgeEl);
          }
          if (badgeEl) {
            badgeEl.textContent = meta.featured_badge;
            badgeEl.style.display = '';
          }
        } else if (badgeEl) {
          badgeEl.style.display = 'none';
        }
      });
    },
    optionChange() {
      this.getOptions();
      this.disableUnavailableOptions();
      this.updateQuantitySwatches();

      const matchedVariant = ShopifyProduct.getVariantFromOptionArray(this.product, this.options);

      this.current_variant = matchedVariant;

      if (this.current_variant) {
        variantLiveRegion(this.current_variant);
        this.updateStoreAvailability(this.current_variant);

        if (this.current_variant.featured_media) {
          this.current_media_id = this.current_variant.featured_media.id;
        }
        const url = ShopifyProductForm.getUrlWithVariant(window.location.href, this.current_variant.id);

        window.history.replaceState({ path: url }, '', url);
        this.$refs.singleVariantSelector.dispatchEvent(new Event('change', { bubbles: true }));
        this.$root.dispatchEvent(
          new CustomEvent('shapes:product:variantchange', {
            bubbles: true,
            detail: { variant: this.current_variant },
          }),
        );
      }
    },
    getOptions() {
      this.options = [];
      this.optionHandles = [];

      let selectors = this.$root.querySelectorAll('[data-single-option-selector]');

      selectors.forEach((selector) => {
        if (selector.nodeName === 'SELECT') {
          const value = selector.value;
          this.options.push(value);
          this.optionHandles.push(selector.options[selector.selectedIndex].dataset.handle);
        } else {
          if (selector.checked) {
            console;
            const value = selector.value;
            this.options.push(value);
            this.optionHandles.push(selector.dataset.handle);
          }
        }
      });
    },
    disableUnavailableOptions() {
      const selectors = this.$root.querySelectorAll('[data-single-option-selector]');
      const processedSelectors = new Set();

      selectors.forEach((selector) => {
        if (processedSelectors.has(selector)) return;

        let optionIndex;
        if (selector.nodeName === 'SELECT') {
          const match = selector.id.match(/Option(\d+)/);
          optionIndex = match ? parseInt(match[1]) - 1 : null;
        } else {
          const optionName = selector.name.match(/options\[([^\]]+)\]/)?.[1];
          optionIndex = optionName ? this.product.options.indexOf(optionName) : null;
        }

        if (optionIndex === null || optionIndex === undefined) return;

        if (selector.nodeName === 'SELECT') {
          Array.from(selector.options).forEach((option) => {
            const isAvailable = this.variantExists(optionIndex, option.value);
            option.disabled = !isAvailable;
          });
          processedSelectors.add(selector);
        } else {
          const groupName = selector.name;
          const inputs = this.$root.querySelectorAll(`input[name="${groupName}"][data-single-option-selector]`);
          inputs.forEach((input) => {
            const isAvailable = this.variantExists(optionIndex, input.value);
            input.disabled = !isAvailable;
            processedSelectors.add(input);
          });
        }
      });
    },
    variantExists(optionIndex, optionValue) {
      return this.product.variants.some((variant) => {
        // Check if all currently selected options at OTHER indices match
        for (let i = 0; i < this.options.length; i++) {
          if (i !== optionIndex && variant.options[i] !== this.options[i]) {
            return false;
          }
        }
        // Check if the option value at this index matches
        if (variant.options[optionIndex] !== optionValue) {
          return false;
        }
        // Return true only if the variant is available
        return variant.available;
      });
    },
    changeMedia(direction) {
      this.$root.dispatchEvent(
        new CustomEvent('shapes:product:arrow-change', {
          bubbles: true,
          detail: { direction: direction },
        }),
      );
      if (this.thumbnailsPosition == 'under') {
        const currentThumbnail = this.$root.querySelector('.product-thumbnail-list-item--active');
        const nextElement =
          direction == 'prev' ? currentThumbnail.previousElementSibling : currentThumbnail.nextElementSibling;
        if (nextElement !== null) {
          nextElement.querySelector('.media-thumbnail').click();
        }
      }
    },
    submitForm(evt) {
      evt.preventDefault();
      this.loading = true;
      this.addedToCart = false;

      liveRegion(window.theme.strings.loading);

      const formData = new FormData(this.$refs.productForm);
      const formId = this.$refs.productForm.getAttribute('id');

      let modalCart = theme.settings.cart_type === 'modal';

      const config = fetchConfigDefaults('javascript');

      if (modalCart) {
        formData.append('sections', 'cart-items,cart-footer,cart-item-count');
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      fetch(`${theme.routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.loading = false;

            const errors = data.errors || data.description;
            const message = data.description || data.message;

            // Gift card recipient form errors are handled in gift-card-recipient.js
            if (!this.hasGiftCardRecipientForm) {
              this.cartAddErrorMessage = message || window.theme.strings.cartError;
            }

            document.body.dispatchEvent(
              new CustomEvent('shapes:cart:adderror', {
                detail: {
                  source: 'product-form',
                  sourceId: formId,
                  variantId: formData.get('id'),
                  errors,
                  message,
                },
              }),
            );
            return;
          }

          this.loading = false;
          this.cartAddErrorMessage = null;
          this.addedToCart = true;

          if (modalCart) {
            document.body.dispatchEvent(
              new CustomEvent('shapes:modalcart:afteradditem', {
                bubbles: true,
                detail: { response: data },
              }),
            );
          }

          // Notify other modules about the updated cart (payload normalized when available)
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data.cart || data } }));
          document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: { cart: data.cart || data } }));

          if (!document.querySelector('[data-show-on-add="true"]')) {
            if (this.$refs.added) this.$nextTick(() => this.$refs.added.focus());
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    openZoom(id) {
      const imageZoomDataEl = this.productRoot.querySelector('[data-photoswipe-images]');

      if (!imageZoomDataEl) return;

      const imageZoomData = JSON.parse(imageZoomDataEl.innerHTML);

      const imageMediaIDsArray = Object.keys(imageZoomData);

      const index = imageMediaIDsArray.indexOf(id);

      this.$refs.photoSwipeComponent.dispatchEvent(
        new CustomEvent('shapes:photoswipe:open', {
          detail: {
            index: index,
          },
        }),
      );
    },
  };
};

window['productThumbnails'] = () => {
  return {
    firstVisible: true,
    lastVisible: false,
    mounted() {
      const firstThumbnail = this.$refs.firstThumbnail;
      const lastThumbnail = this.$refs.lastThumbnail;
      const options = {
        root: this.$root.querySelector('.splide__track'),
        rootMargin: '0px',
        threshold: 1.0,
      };
      const firstThumbnailObserver = new window.IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.firstVisible = true;
        } else {
          this.firstVisible = false;
        }
      }, options);
      const lastThumbnailObserver = new window.IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.lastVisible = true;
        } else {
          this.lastVisible = false;
        }
      }, options);
      firstThumbnailObserver.observe(firstThumbnail);
      lastThumbnailObserver.observe(lastThumbnail);
    },
  };
};

document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('.mobile-thumbs-splide');
  if (!el) return;
  if (el) {
    new Splide(el, {
      autoWidth: true,
      gap: '10px',
      pagination: false,
      arrows: false,
      type: 'slide',
    }).mount();
  }
});
